export default function ComingSoon() {
  return (
    <div className="wrapper">
      {/* MAIN SECTION */}
      <div className="content fade-up">
        <h1>MyWay Deliveryy</h1>

       <p className="headline">
  Coming Soon 🚀
</p>

<p className="subtext">
  We’re building a faster and smarter delivery experience in <strong>Kalaburagi</strong>.
  <br />
  Our services are launching soon. Until then, you can place your order
  using the form below.
</p>


        <a
          href="https://form.jotform.com/mywayofficialco/myway?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAb21jcAPNdMpleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA81NjcwNjczNDMzNTI0MjcAAafwLbWyN1k-wspqeHDFCYnETbJPtwu7qqRwvaWLvpL2233UjjhvmXyDLHgCJA_aem_cI05ARS0zfdPsFsEgj1QFQ"
          target="_blank"
          rel="noreferrer"
          className="primary-btn"
        >
         Place Order via Form

        </a>

       <span className="note">
  We appreciate your interest in MyWay Deliveryy
</span>
      </div>

      {/* BIRTHDAY SECTION */}
      {/* <div className="birthday-section">
        <div className="birthday-card fade-scale">
          <img
            src="/bhava.jpeg"
            alt="Happy Birthday Bhava"
            className="birthday-img"
          />

          <h2>🎉 Happy Birthday Bhava 🎂</h2>

          <p className="birthday-text">
            Wishing you a year filled with success, happiness,
            and unforgettable moments.
          </p>
        </div>
      </div> */}
    </div>
  );
}
